module.exports = __webpack_public_path__ + "static/img/no-banner.38fc9501.png";